<template>
  <div class="row">
    <div class="col">
      <label class="card-category" for="startDate">Filter Start Date</label>
      <select id="startDate" v-model="selectedStartDate" class="form-control" @change="onStartDateChange">
        <option v-for="date in availableDates" :key="date" :value="date">{{ date }}</option>
      </select>
    </div>

    <div class="col">
      <label class="card-category" for="endDate">Filter End Date</label>
      <select id="endDate" v-model="selectedEndDate" class="form-control" @change="onEndDateChange">
        <option v-for="date in filteredEndDates" :key="date" :value="date">{{ date }}</option>
      </select>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        selectedStartDate: '',
        selectedEndDate: '',
        availableDates: [],
        filteredEndDates: []
      };
    },
    props: {
      startTime: Number, // Unix epoch
      endTime: Number   // Unix epoch
    },
    created() {
      this.generateDateRange();
      this.selectedStartDate = this.formatDate(new Date(this.startTime * 1000));
      this.selectedEndDate = this.formatDate(new Date(this.endTime * 1000));
      this.updateFilteredEndDates();
    },
    methods: {
      generateDateRange() {
        let currentDate = new Date(this.startTime * 1000);
        const endDate = new Date(this.endTime * 1000);

        while (currentDate <= endDate) {
          const formattedDate = this.formatDate(currentDate);
          this.availableDates.push(formattedDate);
          currentDate.setDate(currentDate.getDate() + 1);
        }
      },
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      onStartDateChange() {
        this.updateFilteredEndDates();
        this.emitDateRange();
      },
      onEndDateChange() {
        this.emitDateRange();
      },
      updateFilteredEndDates() {
        this.filteredEndDates = this.availableDates.filter(date => date >= this.selectedStartDate);
      },
      emitDateRange() {
        if (this.selectedStartDate && this.selectedEndDate) {
          let currentDate = new Date(this.selectedStartDate);
          const endDate = new Date(this.selectedEndDate);
          const dateRange = [];

          while (currentDate <= endDate) {
            dateRange.push(this.formatDate(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
          }

          console.log('dateRange', dateRange)

          this.$emit('date-range-selected', dateRange);
        }
      }
    }
  }
</script>
<style>
.link-style {
  cursor: pointer; /* Changes cursor to hand symbol */
}
</style>
